export default {
  namespaced: true,

  state: {
    accessToken: null,
    isRefreshing: false
  },

  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token
    },
    setRefreshing(state, isRefreshing) {
      state.isRefreshing = isRefreshing
    }
  },

  actions: {
    logout({ commit }) {
      commit('setAccessToken', null)
    },

    setToken({ commit }, token) {
      commit('setAccessToken', token)
    },

    startRefreshing({ commit }) {
      commit('setRefreshing', true)
    },

    stopRefreshing({ commit }) {
      commit('setRefreshing', false)
    }
  },

  getters: {
    isAuthenticated(state) {
      return !!state.accessToken
    },
    isRefreshingToken(state) {
      return state.isRefreshing
    }
  }
}
